// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d0a3cd50","488":"a895ec99","885":"9cead4b5","977":"b1378e27"}[chunkId] + ".chunk.js";
};